import { IPages, ISocialMedia } from '../types/footer-menu.type';

export const footerPages1: IPages[] = [
  { id: 0, name: 'footer.products', link: 'products' },
  { id: 1, name: 'footer.contactUs', link: 'about' },
  { id: 2, name: 'footer.aboutUs', link: 'about' },
];

export const footerPages2: IPages[] = [
  { id: 0, name: 'footer.services', link: 'services' },
  { id: 1, name: 'footer.auctions', link: 'auctions' },
  { id: 2, name: 'footer.tenders', link: 'tenders' },
];

export const footerSocialMedias: ISocialMedia[] = [
  {
    id: 0,
    title: 'WhatsApp',
    icon: 'assets/icons/footer-icons/whatsapp-gray.svg',
    iconHover: 'assets/icons/footer-icons/whatsapp-primary.svg',
    link: 'https://wa.me/+989932485989',
  },
  {
    id: 1,
    title: 'Instagram',
    icon: 'assets/icons/footer-icons/instagram-gray.svg',
    iconHover: 'assets/icons/footer-icons/instagram-primary.svg',
    link: 'https://instagram.com/wejoiner',
  },
  {
    id: 2,
    title: 'Linkedin',
    icon: 'assets/icons/footer-icons/linkedin-gray.svg',
    iconHover: 'assets/icons/footer-icons/linkedin-primary.svg',
    link: 'https://www.linkedin.com/company/wejoiner',
  },
];
